function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Balance-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "1440px---Energie-gebouw",
  transform: "translate(-130.000000, -1297.000000)",
  stroke: "#425cd4",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-1-Copy-20",
  transform: "translate(136.000000, 1301.000000) scale(1, -1) translate(-136.000000, -1301.000000) ",
  points: "140 1299 136 1303 132 1299"
})));
function SvgEnergyContractArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C47EA5F0-9BCC-4EC4-A7BF-76BB60803236") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyContractArrow);
export default __webpack_public_path__ + "static/media/EnergyContractArrow.454a0b2ca4afee0bc9e4205eeb28ab68.svg";
export { ForwardRef as ReactComponent };